
export const sortResumes = (resumes: any[], sortBy: string) => {
  return resumes.sort((a, b) => {
    if (sortBy === "newest") {
      return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
    }
    if (sortBy === "oldest") {
      return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
    }
    if (sortBy === "name") {
      return a.title.localeCompare(b.title);
    }
    return 0;
  });
};

export const filterResumes = (resumes: any[], searchQuery: string, statusFilter: string) => {
  let filtered = [...resumes];
  
  if (searchQuery) {
    const query = searchQuery.toLowerCase();
    filtered = filtered.filter(resume => 
      resume.title.toLowerCase().includes(query)
    );
  }
  
  if (statusFilter !== "all") {
    filtered = filtered.filter(resume => {
      if (statusFilter === "optimized") return !resume.is_original;
      if (statusFilter === "purchased") return resume.is_paid;
      if (statusFilter === "preview") return !resume.is_paid;
      if (statusFilter === "pending") return resume.status === "pending";
      return true;
    });
  }
  
  return filtered;
};
